
import { HealthState, useCalculations } from '@/lib/calculationstate';
import { computed, defineComponent, toRefs } from 'vue';

import Button from '@/components/Button.vue';
import NVAbbr from '@/components/NVAbbr.vue';
import Slider from '@/components/Slider.vue';
import Explain from '@/components/info/Explain.vue';
import Modal from '@/components/info/Modal.vue';
import { Step, useStepperNavigation } from '@/components/wizard';
import Navigation from '@/components/wizard/Navigation.vue';

export default defineComponent({
  name: 'Disability',
  components: {
    Step,
    Slider,
    NVAbbr,
    Explain,
    Navigation,
    Modal,
    Button,
  },
  props: {
    step: { type: Number, required: true },
  },
  methods: {
    onNextClicked() {
      if (!this.hasHighDisability) {
        this.recoveryNext(false);
        return;
      }

      this.showRecoveryModal = true;
    },

    recoveryNext(cannotRecover: boolean) {
      this.showRecoveryModal = false;
      this.state.cannotRecover = cannotRecover;
      this.nextStep();
    },
  },
  data() {
    return {
      HealthState,
      showRecoveryModal: false,
    };
  },
  setup(props) {
    const { state, hasHighDisability, disabilityPercent } = useCalculations();
    const { step } = toRefs(props);
    const nav = useStepperNavigation(step);
    const isLongSick = computed(() => state.situation === HealthState.LongSick);

    return {
      isLongSick,
      percent: disabilityPercent,
      hasHighDisability,
      state,
      ...nav,
    };
  },
});
